
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Btn from "../common/Btn";
import HeroStat from "../common/HeroStat";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { IProfileWebsite } from "../../../../../services";
import { activeMedia, isPageVisible, pagePath, splitName } from "../../helpers";

export interface HeroProps {
    basePath: string;
    ticker: string[];
    website: IProfileWebsite;
}

function Hero({ website, basePath, ticker }: HeroProps) {

    const labels = i18nManager.Labels;
    const { first, last } = splitName(website.display_name);
    const passport = activeMedia(website, "PASSPORT") ?? activeMedia(website, "HALF_BODY");
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const stats = (website.home_settings?.show_stats && website.extra_data?.stats) ? Object.entries(website.extra_data.stats).slice(0, 4) : [];
    const to = (page: string) => ({ pathname: pagePath(basePath, page), search: searchParams.toString() });

    return (<section className={styles["hero"]}>
        <div className={styles["hero-bg"]} />
        <div className={styles["hero-noise"]} />
        <div className={styles["hero-grid-lines"]} />
        <div className={styles["hero-watermark"]}>{website.extra_data?.jersey_number ?? website.display_name.charAt(0)}</div>

        <div className={styles["hero-body"]}>
            <div className={styles["hero-copy"]}>
                <div className={styles["hero-tag"]}>{website.member.tagline || labels.official_website}</div>
                <h1 className={styles["hero-name"]}>
                    {first && (<span className={styles["hero-name-first"]}>{first}</span>)}
                    <span className={styles["hero-name-last"]}>{last}</span>
                </h1>
                {website.profile_detail && (<p className={styles["hero-bio"]}>{website.profile_detail}</p>)}
                <div className={styles["btn-row"]}>
                    {isPageVisible(website, "MERCH") && (<Btn to={to("MERCH")}>{labels.home.shop_merch}</Btn>)}
                    {isPageVisible(website, "GALLERY") && (<Btn variant="outline" to={to("GALLERY")}>{labels.home.view_gallery}</Btn>)}
                </div>
            </div>

            <div className={styles["hero-player"]}>
                <div className={styles["hero-player-glow"]} />
                <div className={`${styles["hero-ring"]} ${styles["hero-ring-sm"]}`} />
                <div className={`${styles["hero-ring"]} ${styles["hero-ring-lg"]}`} />
                {passport && (<img className={styles["hero-player-img"]} src={passport} alt={website.display_name} />)}
                {(!!website.member?.age) && (<div className={styles["hero-age"]}>
                    <span className={styles["hero-age-num"]}>{website.member.age}</span>
                    <span className={styles["hero-age-lbl"]}>{labels.age}</span>
                </div>)}
            </div>

            <div className={styles["hero-stats"]}>
                {stats.map(([k, v]) => (<HeroStat key={k} value={v as number | string} label={k.replaceAll("_", " ")} />))}
            </div>
        </div>

        <div className={styles["hero-scroll"]}>
            <div className={styles["hero-scroll-line"]} />
            <span>{labels.scroll}</span>
        </div>

        {ticker.length > 0 && (<div className={styles["ticker"]}>
            <div className={styles["ticker-track"]}>
                {[...ticker, ...ticker, ...ticker, ...ticker].map((t, i) => (<span key={i} className={styles["ticker-item"]}>{t}</span>))}
            </div>
        </div>)}
    </section>);
}

export default Hero;
